import { parseSupportingContentItem } from "./SupportingContentParser";

import styles from "./SupportingContent.module.css";
import { Card, CardContent, CardHeader } from "@mui/material";

interface Props {
    supportingContent: string[] | { text: string[]; images?: { url: string }[] };
}

export const SupportingContent = ({ supportingContent }: Props) => {
    const textItems = Array.isArray(supportingContent) ? supportingContent : supportingContent.text;
    const imageItems = !Array.isArray(supportingContent) ? supportingContent?.images : [];
    return (
        <ul className={styles.supportingContentNavList}>
            {textItems.map((c, ind) => {
                const parsed = parseSupportingContentItem(c);
                return (
                    <Card key={ind}>
                        <CardHeader>{parsed.title}</CardHeader>
                        <CardContent dangerouslySetInnerHTML={{ __html: parsed.content }} />
                    </Card>
                );
            })}
            {imageItems?.map((img, ind) => {
                return <img className={styles.supportingContentItemImage} src={img.url} key={ind} />;
            })}
        </ul>
    );
};
